/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react';
import { Button, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import CommonButton from 'app/common/Component/Button/CommonButton';
import Popup from 'app/common/Component/Popup/Popup';
import TableComponent from 'app/common/Component/Table/TableComponent';
import { Form, Formik, useFormikContext } from 'formik';
import { useStore } from "app/stores";
import SaveIcon from '@material-ui/icons/Save';
import BlockIcon from '@material-ui/icons/Block';
import { useTranslation } from "react-i18next";
import { observer } from 'mobx-react';
import GlobitsMultiDatePicker from 'app/common/form/GlobitsMultiDatePicker';
import { Search } from '@material-ui/icons';
import { getDateTime } from "app/common/LocalFunction";
import { getListCode } from "app/services/CustomerSourceService";
import { LEAD_SOURCE_LEVEL } from "app/common/LocalConst";

function OrderDepositDeductionPopup({
    open,
    handleClose
}) {
    const { t } = useTranslation();
    const { setFieldValue, values } = useFormikContext();
    const [selectedRows, setSelectedRows] = useState([]);
    const {
        handleChangeFormSearchOrder,
        dataOrder,
        searchOrder,
        resetStorePopup
    } = useStore().patientManagementStore.voucherDepositDeductionStore;
    const urlParams = new URLSearchParams(window.location.search);
    const patientIdUrl = urlParams.get("patientId");

    const resolveVoucherSearchContext = (values) => {
        const departmentId =
            values?.newTreatmentPlanCard?.department?.id ||
            values?.newPatientServiceRegister?.department?.id ||
            values?.newProduct?.department?.id
            || values?.department?.id
        return {
            listDepId: departmentId ? [departmentId] : [],

            excludeTreatmentPlanCardId:
                values?.oldTreatmentPlanCard?.id ||
                values?.id ||
                null,

            excludePatientServiceRegisterId:
                values?.oldPatientServiceRegister?.id ||
                values?.id ||
                null,

            excludeDrugOrderId:
                values?.oldProduct?.id ||
                values?.id ||
                null,
        };
    };

    useEffect(() => {
        if (!patientIdUrl) return;

        const {
            listDepId,
            excludeTreatmentPlanCardId,
            excludePatientServiceRegisterId,
            excludeDrugOrderId,
        } = resolveVoucherSearchContext(values);

        const payload = {
            patientId: patientIdUrl,
            listDepId,
            excludeTreatmentPlanCardId,
            excludePatientServiceRegisterId,
            excludeDrugOrderId,
        };

        handleChangeFormSearchOrder(payload);
    }, [patientIdUrl, values]);

    const selectedOrderIds = React.useMemo(() => {
        return (
            values?.invoiceItemAllocations?.map(item => item.invoiceItem?.id) || []
        );
    }, [values?.invoiceItemAllocations]);
    const initSelectedRows = React.useMemo(() => {
        if (!dataOrder?.content?.length) return [];

        return dataOrder.content.filter(row =>
            selectedOrderIds.includes(row.id)
        );
    }, [dataOrder?.content, selectedOrderIds]);

    const handleGetListCodeSource = async (obj, setFieldValue) => {
        try {
            const { data } = await getListCode(obj);
            setFieldValue("listCodeSource", data || []);
        } catch (error) {
            //console.error(error);
        }
    }

    const handleClosePopup = () => {
        handleClose();
        resetStorePopup()
    }

    return (
        <Popup
            open={open}
            handleClose={handleClosePopup}
            title={"Danh sách trừ từ đơn hàng"}
            height={"360px"}
            action={
                <>
                    <CommonButton
                        className="mr-2"
                        onClick={() => {
                            const current = values?.invoiceItemAllocations || [];

                            const newItems = selectedRows.map((row) => ({
                                invoiceItem: row,
                            }));

                            const invoiceItemAllocationsData = [...current, ...newItems];

                            setFieldValue(
                                "invoiceItemAllocations",
                                invoiceItemAllocationsData
                            );

                            // patient ko đổi nên lấy từ old được
                            const patientId =
                                values?.patient?.id ||
                                values?.oldTreatmentPlanCard?.patient?.id ||
                                values?.oldPatientServiceRegister?.patient?.id ||
                                values?.oldProduct?.patient?.id;

                            // thông tin khác thì phải lấy từ form hiện tại
                            const voucherAllocations =
                                values?.voucherAllocations ||
                                values?.newTreatmentPlanCard?.voucherAllocations ||
                                values?.newPatientServiceRegister?.voucherAllocations ||
                                values?.newProduct?.voucherAllocations || [];
                            const startDate =
                                values?.startDate ||
                                values?.orderDate ||
                                values?.newTreatmentPlanCard?.startDate ||
                                values?.newTreatmentPlanCard?.orderDate ||
                                values?.newPatientServiceRegister?.startDate ||
                                values?.newPatientServiceRegister?.orderDate ||
                                values?.newProduct?.startDate ||
                                values?.newProduct?.orderDate;
                            const departmentId =
                                values?.department?.id ||
                                values?.newTreatmentPlanCard?.department?.id ||
                                values?.newPatientServiceRegister?.department?.id ||
                                values?.newProduct?.department?.id;


                            const searchCodeSource = {
                                level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                                startDate: startDate,
                                patientId: patientId || patientIdUrl,
                                departmentId: departmentId,

                                voucherIds: Array.isArray(voucherAllocations)
                                    ? voucherAllocations
                                        .map(item => item?.voucher?.id)
                                        .filter(Boolean)
                                    : [],

                                invoiceItemIds: Array.isArray(invoiceItemAllocationsData)
                                    ? invoiceItemAllocationsData
                                        .map(item => item?.invoiceItem?.id)
                                        .filter(Boolean)
                                    : [],
                            };

                            handleGetListCodeSource(searchCodeSource, setFieldValue);
                            handleClose();
                        }}
                    >
                        <SaveIcon /> {t("save")}
                    </CommonButton>

                    <CommonButton className="btn-gray" onClick={handleClose} >
                        <BlockIcon /> {t('cancel')}
                    </CommonButton>
                </>
            }
        >
            <Formik
                initialValues={{
                    fromDate: null,
                    toDate: null,
                }}
                onSubmit={handleChangeFormSearchOrder}
                enableReinitialize
            >
                {({ setFieldValue }) => {
                    return (
                        <Form autoComplete='off'>
                            <section className="cards-container">
                                <Grid container spacing={1}>
                                    <Grid container spacing={1} className="cards-body flex flex-end mt-2" >
                                        <Grid item xs={12} sm={6} md={10} >
                                            <GlobitsMultiDatePicker
                                                label="Từ ngày - đến ngày"
                                                name="fromDate"
                                                range
                                                rangeHover
                                                fromField="fromDate"
                                                toField="toDate"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2} className="flex">
                                            <Button className="btn-primary" type="submit">
                                                <Search />
                                                Tìm kiếm
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TableComponent
                                            className=""
                                            showOrdinalNumbers
                                            selectType="multi"
                                            handleChangeSelectedRows={(rows) => {
                                                const filtered = rows.filter(
                                                    row => !selectedOrderIds.includes(row.id)
                                                );
                                                setSelectedRows(filtered);
                                            }}
                                            initStateRow={initSelectedRows}
                                            titleNodata={"Không có dữ liệu"}
                                            data={dataOrder?.content || []}
                                            columns={[
                                                {
                                                    field: "invoiceDate",
                                                    title: "Ngày lên đơn hàng",
                                                    render: (row) => getDateTime(row?.invoiceDate)
                                                },
                                                {
                                                    field: "code",
                                                    title: "Mã đơn hàng",
                                                    render: (row) => row?.patientServiceRegister?.code || row?.treatmentPlanCard?.code || row?.drugOrder?.code
                                                },
                                                {
                                                    field: "note",
                                                    title: "Tên đơn hàng",
                                                    align: "right",
                                                    render: (item) => item?.invoiceItemName || item?.patientServiceRegister?.name || item?.treatmentPlanCard?.name || item?.drugOrder?.name,
                                                },
                                                {
                                                    field: "department",
                                                    title: "Cơ sở",
                                                    align: "right",
                                                    render: (item) => item?.department?.name,
                                                },
                                            ]}
                                            dataPagination={{
                                                pageIndex: searchOrder?.pageIndex,
                                                pageSize: searchOrder?.pageSize,
                                                totalElements: dataOrder?.totalElements,
                                                totalPages: dataOrder?.totalPages,
                                                setPageIndex: (pageIndex) =>
                                                    handleChangeFormSearchOrder({ pageIndex }),
                                                setPageSize: (pageSize) =>
                                                    handleChangeFormSearchOrder({ pageSize }),
                                            }}
                                        />

                                    </Grid>
                                </Grid>
                            </section>
                        </Form>
                    );
                }}
            </Formik>
        </Popup>
    );
}

export default memo(observer(OrderDepositDeductionPopup));
